import Cookies from "js-cookie";

export const loginCookies = Cookies.withAttributes({
  domain: process.env.REACT_APP_LOGIN_COOKIE_DOMAIN,
  expires: 7,
});
